import * as Yup from 'yup';
import phoneNumber from '../../schemas/phoneNumber';

export default Yup.object().shape({
  name: Yup.string()
    .required('Il nome è richiesto'),
  email: Yup.string().email('L\'email non ha un formato corretto')
    .required('L\'email è richiesta'),
  phoneNumber: Yup.string()
    .required('Il recapito telefonico è necessario')
    .concat(phoneNumber),
});
